import Link from 'next/link';
import React from 'react';

interface ITitleProps {
  label: string;
  url: string;
  dataTestId?: string;
}

export const Title: React.FC<ITitleProps> = ({
  label,
  url,
  dataTestId = '',
}) => (
  <Link
    className="tw-text-black tw-lf-title-sm tw-line-clamp-3 tw-text-center tw-underline tw-decoration-transparent tw-underline-offset-2 tw-duration-300 hover:tw-decoration-black-1000"
    href={url}
    title={label}
    data-testid={dataTestId}
  >
    {label}
  </Link>
);
